import { render, staticRenderFns } from "./FilesModal.vue?vue&type=template&id=a0620da0&"
import script from "./FilesModal.vue?vue&type=script&lang=js&"
export * from "./FilesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports